import Cookies from 'js-cookie';
import { FormValidator } from './FormValidator';

export const Helpers = (() => {
	'use strict';

	function init() {
		searchToggle();
        navToggle();
        mobileMenuToggle();
        menuToggle();
        initRegionSelect();
        formatUMLoginForm();
        formatUMRegisterForm();
        formatUMRegisterSuccess();
        formatUMResetPasswordForm();
        formatUMAccountForm();
        formatLegalPages();
        addLogoToCookieBanner();
        addCookiePreferencesLink();
        formatContactModal();
        initFormValidation();
        formatUSPrivacyPolicy();
        initCSVDownload();
	}

    function searchToggle() {
        const wrapper = document.querySelector('.search-wrapper');
        const input = document.querySelector('.search-input');
        const iconButton = document.querySelector('.search-icon-button');
        const closeButton = document.querySelector('.search-close');
        const mobileMenuToggle = document.querySelector('#mobileMenuToggle');

        if (wrapper) {
            // Helper to set focusability
            const setSearchTabIndex = (focusable) => {
                if (focusable) {
                    input.removeAttribute('tabindex');
                    closeButton.removeAttribute('tabindex');
                } else {
                    input.setAttribute('tabindex', '-1');
                    closeButton.setAttribute('tabindex', '-1');
                }
            };

            // Set initial state
            if (wrapper.dataset.expanded === 'true') {
                setSearchTabIndex(true);
            } else {
                setSearchTabIndex(false);
            }

            if (iconButton) {
                iconButton.addEventListener('click', (e) => {
                    if (wrapper.dataset.expanded === 'false') {
                        e.preventDefault(); // prevent submit
                        wrapper.dataset.expanded = 'true';
                        iconButton.setAttribute('aria-expanded', 'true');
                        input.removeAttribute('aria-hidden');
                        input.focus();
                        if (mobileMenuToggle) {
                            mobileMenuToggle.classList.add('opacity-0');
                            mobileMenuToggle.classList.add('pointer-events-none');
                        }
                        setSearchTabIndex(true);
                    }
                    // else, it's a normal form submit
                });
            }

            if (closeButton) {
                closeButton.addEventListener('click', () => {
                    wrapper.dataset.expanded = 'false';
                    if (iconButton) {
                        iconButton.setAttribute('aria-expanded', 'false');
                    }
                    input.setAttribute('aria-hidden', 'true');
                    input.value = '';
                    if (mobileMenuToggle) {
                        mobileMenuToggle.classList.remove('opacity-0');
                        mobileMenuToggle.classList.remove('pointer-events-none');
                    }
                    setSearchTabIndex(false);
                });
            }
        }
    }

    function navToggle() {
        const navItems = document.querySelectorAll('.nav-items .menu-item-has-children');
        const currentNavItem = document.querySelector('.nav-items .current-menu-parent');

        // Helper to set focusability of submenu links
        const setSubmenuTabIndex = (submenu, focusable) => {
            if (!submenu) return;
            const links = submenu.querySelectorAll('a, button, input, [tabindex]');
            links.forEach(link => {
                if (focusable) {
                    link.removeAttribute('tabindex');
                } else {
                    link.setAttribute('tabindex', '-1');
                }
            });
        };

        navItems.forEach(item => {
            const trigger = item.querySelector(':scope > .menu-link');
            const content = item.querySelector('.sub-menu');

            // Set initial state
            if (item == currentNavItem) {
                content.setAttribute('aria-hidden', 'false');
                trigger.setAttribute('aria-expanded', 'true');
                setSubmenuTabIndex(content, true);
            } else {
                content.setAttribute('aria-hidden', 'true');
                trigger.setAttribute('aria-expanded', 'false');
                content.style.height = '0px';
                setSubmenuTabIndex(content, false);
            }

            const expand = (submenu) => {
                submenu.classList.add('expanding');
                submenu.style.height = submenu.scrollHeight + 'px';
                submenu.setAttribute('aria-hidden', 'false');
                setSubmenuTabIndex(submenu, true);

                submenu.addEventListener('transitionend', function handler() {
                    submenu.classList.remove('expanding');
                    submenu.style.height = 'auto';
                    submenu.removeEventListener('transitionend', handler);
                });
            };

            const collapse = (submenu) => {
                submenu.classList.add('collapsing');
                submenu.style.height = submenu.scrollHeight + 'px'; // set current height first
                submenu.offsetHeight; // force reflow
                submenu.style.height = '0px';
                submenu.setAttribute('aria-hidden', 'true');
                setSubmenuTabIndex(submenu, false);

                submenu.addEventListener('transitionend', function handler() {
                    submenu.classList.remove('collapsing');
                    // submenu.style.height = '';
                    submenu.removeEventListener('transitionend', handler);
                });
            };

            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

                // Collapse all others
                navItems.forEach(otherItem => {
                    const otherTrigger = otherItem.querySelector(':scope > .menu-link');
                    const otherContent = otherItem.querySelector('.sub-menu');

                    if (otherItem !== item) {
                        otherTrigger.setAttribute('aria-expanded', 'false');
                        collapse(otherContent);
                    }
                });

                // Toggle current item
                trigger.setAttribute('aria-expanded', String(!isExpanded));
                if (isExpanded) {
                    collapse(content);
                } else {
                    expand(content);
                }
            });

            // Optional: keyboard support
            trigger.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    trigger.click();
                }
            });
        });
    }

    function menuToggle() {
        const menuToggle = document.querySelector('#menuToggle');
        const sidebar = document.querySelector('#sidebar');
        
        if (menuToggle && sidebar) {
            menuToggle.addEventListener('click', () => {
                const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
                menuToggle.setAttribute('aria-expanded', !isExpanded);
                if (isExpanded) {
                    sidebar.classList.remove('expanded');
                } else {
                    sidebar.classList.add('expanded');
                }
            });
        }
    }

    function mobileMenuToggle() {
        const mobileMenuToggle = document.querySelector('#mobileMenuToggle');
        const sidebar = document.querySelector('#sidebar');

        if (mobileMenuToggle && sidebar) {
            mobileMenuToggle.addEventListener('click', () => {
                const isExpanded = mobileMenuToggle.getAttribute('aria-expanded') === 'true';
                mobileMenuToggle.setAttribute('aria-expanded', !isExpanded);
                sidebar.classList.toggle('-translate-x-full');
                sidebar.classList.toggle('translate-x-0');
                
                // Add/remove class to body when mobile nav is open
                if (!isExpanded) {
                    // Add delay to account for animation
                    setTimeout(() => {
                        document.body.classList.add('mobile-nav-open');
                    }, 300);
                } else {
                    document.body.classList.remove('mobile-nav-open');
                }
            });
        }
    }

    // Initialize region select dropdown
    function initRegionSelect() {
        const select = document.getElementById('region-select');
        if (!select) return;

        const isLoggedIn = document.body.classList.contains('logged-in');

        // Map select values to region slugs for storage/cookie
        const valueToRegion = {
            'semicon-korea': 'korea',
            'semicon-china': 'china',
            'semicon-southeast-asia': 'southeast-asia',
            'semicon-taiwan': 'taiwan',
            'semicon-west': 'west',
            'semicon-india': 'india',
            'semicon-europa': 'europa',
            'semicon-japan': 'japan',
        };

        // Initialize Choices.js
        if (typeof Choices !== 'undefined') {
            const choices = new Choices(select, {
                searchEnabled: false,
                itemSelectText: '',
                shouldSort: false,
                position: 'bottom',
                allowHTML: false,
                classNames: {
                    containerOuter: 'choices region-choices-container',
                    containerInner: 'choices__inner',
                    input: 'choices__input',
                    inputCloned: 'choices__input--cloned',
                    list: 'choices__list',
                    listItems: 'choices__list--multiple',
                    listSingle: 'choices__list--single',
                    listDropdown: 'choices__list--dropdown',
                    item: 'choices__item',
                    itemSelectable: 'choices__item--selectable',
                    itemDisabled: 'choices__item--disabled',
                    itemChoice: 'choices__item--choice',
                    placeholder: 'choices__placeholder',
                    group: 'choices__group',
                    groupHeading: 'choices__heading',
                    button: 'choices__button',
                    activeState: 'is-active',
                    focusState: 'is-focused',
                    openState: 'is-open',
                    disabledState: 'is-disabled',
                    flippedState: 'is-flipped',
                    loadingState: 'is-loading',
                    noResults: 'has-no-results',
                    noChoices: 'has-no-choices'
                }
            });

            // Handle region selection
            choices.passedElement.element.addEventListener('change', function() {
                const selected = this.value;
                
                // Check if the selected option is disabled
                const selectedOption = this.querySelector(`option[value="${selected}"]`);
                if (selectedOption && selectedOption.disabled) {
                    // Reset to empty if disabled option is selected
                    choices.setChoiceByValue('');
                    return;
                }
                
                // Trigger form validation for the region field
                const form = this.closest('form');
                if (form && window.formValidators && window.formValidators[form]) {
                    const formValidator = window.formValidators[form];
                    formValidator.validateFieldByName('region');
                    formValidator.updateSubmitButtonState();
                }
                
                if (valueToRegion[selected]) {
                    window.setRegion(valueToRegion[selected]);

                    if (isLoggedIn) {
                        choices.setChoiceByValue('');
                        // Update URL to show the selected region for deep linking
                        const url = new URL(window.location);
                        url.searchParams.set('region', valueToRegion[selected]);
                        window.history.replaceState({}, '', url);
                        location.reload();
                    }
                    // If logged out: do nothing else
                }
            });

            // Mark field as touched when user focuses on the dropdown
            choices.passedElement.element.addEventListener('focus', function() {
                // Mark the field as touched when user interacts with it
                const form = this.closest('form');
                if (form && window.formValidators && window.formValidators[form]) {
                    const formValidator = window.formValidators[form];
                    const field = formValidator.getFieldByName('region');
                    if (field) {
                        field.touched = true;
                    }
                }
            });




        } else {
            // Fallback to native select if Choices.js is not loaded
            select.addEventListener('change', function() {
                const selected = select.value;
                
                // Check if the selected option is disabled
                const selectedOption = this.querySelector(`option[value="${selected}"]`);
                if (selectedOption && selectedOption.disabled) {
                    // Reset to empty if disabled option is selected
                    select.value = '';
                    return;
                }
                
                if (valueToRegion[selected]) {
                    window.setRegion(valueToRegion[selected]);

                    if (isLoggedIn) {
                        select.value = '';
                        // Update URL to show the selected region for deep linking
                        const url = new URL(window.location);
                        url.searchParams.set('region', valueToRegion[selected]);
                        window.history.replaceState({}, '', url);
                        location.reload();
                    }
                    // If logged out: do nothing else
                }
            });
        }
    }

    function formatUMLoginForm() {
        const umLoginForm = document.querySelector('.um-login form');
        if (!umLoginForm) return;

        const umRowTop = umLoginForm.querySelector('.custom-um-row-top');
        const umRowBottom = umLoginForm.querySelector('.custom-um-row-bottom');

        const rememberMe = umLoginForm.querySelector('input[name="rememberme"]');
        const forgotPassword = umLoginForm.querySelector('.um-link-alt');
        const submitButton = umLoginForm.querySelector('#um-submit-btn');
        
        // Move rememberMe to umRowTop
        if (rememberMe && umRowTop) {
            const rememberMeWrapper = rememberMe.closest('.um-field');
            if (rememberMeWrapper) {
                umRowTop.appendChild(rememberMeWrapper);
                
                // Change the label text to "Remember me"
                const label = rememberMeWrapper.querySelector('.um-field-checkbox-option');
                if (label) {
                    label.textContent = 'Remember me';
                }
            }
            // Move forgotPassword after rememberMeWrapper
            if (forgotPassword) {
                rememberMeWrapper.after(forgotPassword);
                // Change the text of forgotPassword
                forgotPassword.textContent = 'Lost your password?';
            }
        }
        // Move submitButton to umRowBottom
        if (submitButton && umRowBottom) {
            umRowBottom.appendChild(submitButton);
        }
    }

    function formatUMRegisterForm() {
        const registerForm = document.querySelector('.um-register form');
        if (!registerForm) return;
        
        // Move confirm password to specific column
        const confirmPassword = registerForm.querySelector('#um_field_481_confirm_user_password');
        const umRow3Col122 = registerForm.querySelector('.um-row._um_row_3 .um-col-122');
        if (confirmPassword && umRow3Col122) {
            umRow3Col122.appendChild(confirmPassword);
        }

        // Add password help text
        const umRow3 = registerForm.querySelector('.um-row._um_row_3');
        if (umRow3) {
            const div = document.createElement('div');
            div.className = 'help-text';
            div.innerHTML = `
                <p>For a strong password:</p>
                <ul>
                    <li>Passwords must be between 8 and 64 characters in length.</li>
                    <li>Passwords must contain at least 1 lowercase letter, 1 uppercase letter, and 1 number.</li>
                </ul>
            `;
            umRow3.appendChild(div);
        }

        // Add custom multi-select regions field
        const umRow4Col121 = registerForm.querySelector('.um-row._um_row_4 .um-col-121');
        if (umRow4Col121) {
            const customRegionsField = document.createElement('div');
            customRegionsField.className = 'um-field um-field-multiselect um-field-user_regions';
            customRegionsField.setAttribute('data-key', 'user_regions');
            
            // Get regions from centralized PHP function
            const regions = window.SEMICON_REGIONS || [];
            
            // Generate checkbox HTML dynamically
            const checkboxHTML = regions.map(region => `
                <div class="checkbox-item">
                    <input type="checkbox" id="region-${region.key.replace('semicon-', '')}" value="${region.key}">
                    <label for="region-${region.key.replace('semicon-', '')}">${region.label}</label>
                </div>
            `).join('');
            
            customRegionsField.innerHTML = `
                <div class="um-field-area">
                    <div class="region-selector relative">
                        <label for="custom-regions-trigger" class="sr-only">Select Regions</label>
                        <button id="custom-regions-trigger" class="region-choices-select" type="button">
                            Select Regions
                        </button>
                        <div id="custom-regions-dropdown" class="custom-regions-dropdown" style="display: none;">
                            ${checkboxHTML}
                        </div>
                    </div>
                </div>
                <span class="help-text">Select all regions that apply to your organization</span>
            `;
            
            umRow4Col121.appendChild(customRegionsField);
            
            // Add event listeners for custom regions dropdown
            const customRegionsTrigger = customRegionsField.querySelector('#custom-regions-trigger');
            const customRegionsDropdown = customRegionsField.querySelector('#custom-regions-dropdown');
            const customRegionsCheckboxes = customRegionsField.querySelectorAll('input[type="checkbox"]');
            
            if (customRegionsTrigger && customRegionsDropdown) {
                // --- Click outside handler ---
                function handleClickOutsideRegionsDropdown(e) {
                    if (!customRegionsTrigger.classList.contains('expanded')) return;
                    if (
                        !customRegionsTrigger.contains(e.target) &&
                        !customRegionsDropdown.contains(e.target)
                    ) {
                        customRegionsDropdown.style.display = 'none';
                        customRegionsTrigger.classList.remove('expanded');
                        document.removeEventListener('click', handleClickOutsideRegionsDropdown, true);
                    }
                }
                // Toggle dropdown on button click
                customRegionsTrigger.addEventListener('click', function() {
                    const isVisible = customRegionsDropdown.style.display !== 'none';
                    customRegionsDropdown.style.display = isVisible ? 'none' : 'flex';
                    if (isVisible) {
                        customRegionsTrigger.classList.remove('expanded');
                        document.removeEventListener('click', handleClickOutsideRegionsDropdown, true);
                    } else {
                        customRegionsTrigger.classList.add('expanded');
                        // Add the outside click listener (delay to avoid immediate close)
                        setTimeout(() => {
                            document.addEventListener('click', handleClickOutsideRegionsDropdown, true);
                        }, 0);
                    }
                });
                
                // Update hidden field when checkboxes change
                customRegionsCheckboxes.forEach(checkbox => {
                    checkbox.addEventListener('change', function() {
                        const selectedValues = Array.from(customRegionsCheckboxes)
                            .filter(cb => cb.checked)
                            .map(cb => cb.value);
                        
                        const hiddenField = registerForm.querySelector('input[name*="user_regions"]');
                        if (hiddenField) {
                            hiddenField.value = JSON.stringify(selectedValues);
                        }
                        
                        // Update button text
                        if (selectedValues.length === 0) {
                            customRegionsTrigger.textContent = 'Select Regions';
                        } else {
                            customRegionsTrigger.textContent = `${selectedValues.length} selected`;
                        }
                    });
                });
            }
        }

        // Wrap user email field and add confirm email
        const userEmail = registerForm.querySelector('#um_field_481_user_email');
        if (userEmail) {
            // Create wrapper div
            const emailWrapper = document.createElement('div');
            emailWrapper.className = 'email-fields-wrapper';
            
            // Move the user email field into the wrapper
            userEmail.parentNode.insertBefore(emailWrapper, userEmail);
            emailWrapper.appendChild(userEmail);
            
            // Add help text to user email
            const span = document.createElement('span');
            span.textContent = 'Your email is your username';
            span.className = 'help-text';
            userEmail.appendChild(span);
            
            // Create confirm email field
            const confirmEmail = document.createElement('div');
            confirmEmail.className = 'um-field um-field-text um-field-confirm_user_email um-field-area';
            confirmEmail.innerHTML = `
                <div class="um-field-label">
                    <label for="confirm_user_email">Confirm Email <span class="um-req" title="Required">*</span></label>
                </div>
                <div class="um-field-area">
                    <input type="text" name="confirm_user_email" id="confirm_user_email" class="um-form-field" required>
                </div>
            `;
            
            // Add confirm email to wrapper
            emailWrapper.appendChild(confirmEmail);
        }

        // Add registration code help text
        const registrationCode = registerForm.querySelector('#um_field_481_registration_code');
        if (registrationCode) {
            const span = document.createElement('span');
            span.textContent = 'No registration code? Ask your SEMI contact.';
            span.className = 'help-text';
            registrationCode.appendChild(span);
        }
    }

    function formatUMRegisterSuccess() {
        const registerSuccess = document.querySelector('.um-register .um-postmessage');
        if (!registerSuccess) return;

        // Create inner wrapper for post message styling
        const innerWrapper = document.createElement('div');
        innerWrapper.className = 'post-message-wrapper';
        
        // Wrap the success message in the inner wrapper
        registerSuccess.parentNode.insertBefore(innerWrapper, registerSuccess);
        innerWrapper.appendChild(registerSuccess);

        // Create and insert success SVG icon
        const successIcon = document.createElement('div');
        successIcon.className = 'success-icon';
        successIcon.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clip-path="url(#clip0_232_26224)">
        <circle cx="15.9999" cy="16" r="9.17517" fill="white"/>
        <path d="M16.0001 2.66663C8.64008 2.66663 2.66675 8.63996 2.66675 16C2.66675 23.36 8.64008 29.3333 16.0001 29.3333C23.3601 29.3333 29.3334 23.36 29.3334 16C29.3334 8.63996 23.3601 2.66663 16.0001 2.66663ZM13.3334 22.6666L6.66675 16L8.54675 14.12L13.3334 18.8933L23.4534 8.77329L25.3334 10.6666L13.3334 22.6666Z" fill="#55A51C"/>
        </g>
        <defs>
        <clipPath id="clip0_232_26224">
        <rect width="32" height="32" fill="white"/>
        </clipPath>
        </defs>
        </svg>`;
        
        // Insert icon before the success message
        innerWrapper.insertBefore(successIcon, registerSuccess);

        // Create main wrapper div
        const wrapper = document.createElement('div');
        wrapper.className = 'registration-success-wrapper';
        
        // Create form header with the same structure as register.php
        const formHeader = document.createElement('div');
        formHeader.className = 'um-form-header';
        formHeader.innerHTML = '<h1 class="um-form-title">Register</h1><span>Already have an account? <a href="/login/" class="um-link-alt">Log in</a>.</span>';
        
        // Move the inner wrapper (with success message) into the main wrapper
        innerWrapper.parentNode.insertBefore(wrapper, innerWrapper);
        
        // Insert form header first, then inner wrapper with success message
        wrapper.appendChild(formHeader);
        wrapper.appendChild(innerWrapper);
    }

    function formatUMResetPasswordForm() {
        const resetPasswordForm = document.querySelector('.um-password form');
        if (!resetPasswordForm) return;
        
        const emailField = resetPasswordForm.querySelector('#um_field_0_username_b');
        if (emailField) {
            // Create and insert label
            const label = document.createElement('label');
            label.textContent = 'User Email';
            label.setAttribute('for', 'username_b');
            
            // Add required asterisk
            const requiredSpan = document.createElement('span');
            requiredSpan.className = 'um-req';
            requiredSpan.title = 'Required';
            requiredSpan.textContent = '*';
            label.appendChild(requiredSpan);
            
            // Create wrapper div
            const labelWrapper = document.createElement('div');
            labelWrapper.className = 'um-field-label';
            labelWrapper.appendChild(label);
            
            // Insert wrapper as first child
            emailField.insertBefore(labelWrapper, emailField.firstChild);

            const input = emailField.querySelector('#username_b');
            if (input) {
                input.placeholder = '';
            }
        }
    }

    function formatUMAccountForm() {
        const accountForm = document.querySelector('.um-account form');
        if (!accountForm) return;

        const privacySubmitButton = accountForm.querySelector('#um_account_submit_privacy');
        
        if (privacySubmitButton) {
            privacySubmitButton.addEventListener('click', (e) => {
                e.preventDefault();
            });
        }

        const detailsTabButton = accountForm.querySelector('a[data-tab="general"]');
        if (detailsTabButton) {
            const title = detailsTabButton.querySelector('.um-account-title');
            if (title) {
                title.textContent = 'Details';
                title.dataset.content = 'Details';
            }
        }

        const passwordTabButton = accountForm.querySelector('a[data-tab="password"]');
        if (passwordTabButton) {
            const title = passwordTabButton.querySelector('.um-account-title');
            if (title) {
                title.dataset.content = 'Change Password';
            }
        }

        const privacyTabButton = accountForm.querySelector('a[data-tab="privacy"]');
        if (privacyTabButton) {
            const title = privacyTabButton.querySelector('.um-account-title');
            if (title) {
                title.dataset.content = 'Privacy';
            }
        }
        
        const emailAddressField = accountForm.querySelector('#um_field_0_user_email');
        const companyNameField = accountForm.querySelector('.um-field.um-field-company_name');
        
        if (emailAddressField && companyNameField) {
            // Move email field after company name field
            companyNameField.parentNode.insertBefore(emailAddressField, companyNameField.nextSibling);
            
            const label = emailAddressField.querySelector('.um-field-label label');
            if (label) {
                label.textContent = 'User Email';
            }
        }
        
        // Wrap first name and last name fields in a div
        const firstNameField = accountForm.querySelector('#um_field_0_first_name');
        const lastNameField = accountForm.querySelector('#um_field_0_last_name');
        
        if (firstNameField && lastNameField) {
            // Create wrapper div
            const wrapper = document.createElement('div');
            wrapper.className = 'name-fields-wrapper';
            
            // Insert wrapper before the first name field
            firstNameField.parentNode.insertBefore(wrapper, firstNameField);
            
            // Move both fields into the wrapper
            wrapper.appendChild(firstNameField);
            wrapper.appendChild(lastNameField);
        }

        const detailsSubmitButton = accountForm.querySelector('#um_account_submit_general');
        if (detailsSubmitButton) {
            detailsSubmitButton.value = 'Save Changes';
        }

        const passwordSubmitButton = accountForm.querySelector('#um_account_submit_password');
        if (passwordSubmitButton) {
            passwordSubmitButton.value = 'Save Changes';
        }

        const confirmUserPasswordField = accountForm.querySelector('#um_field_0_confirm_user_password');
        if (confirmUserPasswordField) {
            const label = confirmUserPasswordField.querySelector('.um-field-label label');
            if (label) {
                label.innerHTML = 'Confirm New Password<span class="um-req" title="Required">*</span>';
            }
        }

        const exportDataField = accountForm.querySelector('#um-export-data');
        if (exportDataField) {
            const exportDataWrapper = exportDataField.closest('.um-field.um-field-export_data');

            if (exportDataWrapper) {
                const exportDataLabel = exportDataWrapper.querySelector('label[for="um-export-data"]');
                const exportDataInput = exportDataWrapper.querySelector('.um-field-area');

                if (exportDataLabel && exportDataInput) {
                    exportDataInput.parentNode.insertBefore(exportDataLabel, exportDataInput.nextSibling);
                }
            }
        }

        const eraseDataField = accountForm.querySelector('#um-erase-data');
        if (eraseDataField) {
            const eraseDataWrapper = eraseDataField.closest('.um-field.um-field-export_data');

            if (eraseDataWrapper) {
                const visualLabel = eraseDataWrapper.querySelector('.um-field-label');
                if (visualLabel) {
                    visualLabel.innerHTML = '<label>Erase Your Data</label>';
                }

                const eraseDataLabel = eraseDataWrapper.querySelector('label[for="um-erase-data"]');
                const eraseDataInput = eraseDataWrapper.querySelector('.um-field-area');

                if (eraseDataLabel && eraseDataInput) {
                    eraseDataInput.parentNode.insertBefore(eraseDataLabel, eraseDataInput.nextSibling);
                }
            }
        }

        const privacyTab = accountForm.querySelector('.um-account-tab.um-account-tab-privacy');
        if (privacyTab) {
            const wrapper = document.createElement('div');
            wrapper.className = 'privacy-policy-wrapper';
            const paragraph = document.createElement('p');
            paragraph.innerHTML = 'By having an account you have accepted that SEMI will send occasional communications by email about training opportunities and updates to assets contained on the site. Having an account also constitutes your acceptance of the <a href="/terms-of-use/" class="um-link-alt">terms of use</a> and the <a href="/privacy-policy/" class="um-link-alt">privacy policy</a>.';
            wrapper.appendChild(paragraph);

            const deleteAccountWrapper = document.createElement('div');
            deleteAccountWrapper.className = 'delete-account-wrapper';
            const deleteAccountParagraph = document.createElement('p');
            deleteAccountParagraph.innerHTML = 'If you no longer wish to use the SEMICON brand guidelines site, you can delete your account.';
            deleteAccountWrapper.appendChild(deleteAccountParagraph);

            const deleteAccountButton = document.createElement('a');
            deleteAccountButton.className = 'btn btn--delete';
            deleteAccountButton.href = '/account/delete/';
            deleteAccountButton.innerHTML = `
               <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path d="M5.16669 14C4.80002 14 4.48613 13.8694 4.22502 13.6083C3.96391 13.3472 3.83335 13.0333 3.83335 12.6667V4H3.16669V2.66667H6.50002V2H10.5V2.66667H13.8334V4H13.1667V12.6667C13.1667 13.0333 13.0361 13.3472 12.775 13.6083C12.5139 13.8694 12.2 14 11.8334 14H5.16669ZM11.8334 4H5.16669V12.6667H11.8334V4ZM6.50002 11.3333H7.83335V5.33333H6.50002V11.3333ZM9.16669 11.3333H10.5V5.33333H9.16669V11.3333Z" fill="currentColor"/>
                </svg>
                <span>Delete Account</span>
            `;
            deleteAccountWrapper.appendChild(deleteAccountButton);

            privacyTab.insertBefore(wrapper, privacyTab.firstChild);
            privacyTab.insertBefore(deleteAccountWrapper, privacyTab.lastChild.nextSibling);

            const deleteTab = accountForm.querySelector('.um-account-tab.um-account-tab-delete');
            if (deleteTab) {
                const deleteTabButton = deleteTab.querySelector('#um_account_submit_delete');
                
                if (deleteTabButton) {
                    const parent = deleteTabButton.parentNode;
                    const deleteTabButtonWrapper = document.createElement('div');
                    deleteTabButtonWrapper.className = 'delete-tab-button-wrapper';

                    deleteTabButtonWrapper.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                     <path d="M5.16669 14C4.80002 14 4.48613 13.8694 4.22502 13.6083C3.96391 13.3472 3.83335 13.0333 3.83335 12.6667V4H3.16669V2.66667H6.50002V2H10.5V2.66667H13.8334V4H13.1667V12.6667C13.1667 13.0333 13.0361 13.3472 12.775 13.6083C12.5139 13.8694 12.2 14 11.8334 14H5.16669ZM11.8334 4H5.16669V12.6667H11.8334V4ZM6.50002 11.3333H7.83335V5.33333H6.50002V11.3333ZM9.16669 11.3333H10.5V5.33333H9.16669V11.3333Z" fill="currentColor"/>
                     </svg>
                    `;
                    deleteTabButtonWrapper.appendChild(deleteTabButton);
                    parent.appendChild(deleteTabButtonWrapper);
                }

                const buttonRow = deleteTab.querySelector('.um-col-alt.um-col-alt-b');
                if (buttonRow) {
                    const cancelButtonWrapper = document.createElement('div');
                    cancelButtonWrapper.className = 'cancel-button-wrapper';
                    cancelButtonWrapper.innerHTML = `
                        <a href="/account/privacy/" class="btn btn--cancel">Cancel</a>
                    `;
                    buttonRow.appendChild(cancelButtonWrapper);
                }
            }
        }
    }

    function formatLegalPages() {
        if (!document.body.classList.contains('legal-page')) {
            return;
        }
        
        const legalPage = document.querySelector('.legal-page');
        const cmplzCookiesOverview = legalPage.querySelector('#cmplz-cookies-overview');
        const cmplzDocument = legalPage.querySelector('#cmplz-document');
        if (cmplzCookiesOverview) {
            const paragraphs = cmplzCookiesOverview.querySelectorAll('p');
            paragraphs.forEach(paragraph => {
                paragraph.innerHTML = paragraph.innerHTML.replace(/&nbsp;/g, ' ');
            });
        }
        if (cmplzDocument) {
            const paragraphs = cmplzDocument.querySelectorAll('p');
            paragraphs.forEach(paragraph => {
                paragraph.innerHTML = paragraph.innerHTML.replace(/&nbsp;/g, ' ');
            });

            const cookiePolicyLinks = cmplzDocument.querySelectorAll('a[href=""]');
            cookiePolicyLinks.forEach(link => {
                if (link.innerHTML.toLowerCase().includes('cookie policy')) {
                    link.href = '/cookie-policy-eu/?cmplz_region_redirect=true';
                }
            });
        }
    }

    function addLogoToCookieBanner() {
        const cookieBanners = document.querySelectorAll('.cmplz-cookiebanner');
        if (cookieBanners) {
            cookieBanners.forEach(banner => {
                const cmplzHeader = banner.querySelector('.cmplz-header');
            if (cmplzHeader) {
                // Create the logo div
                const logoDiv = document.createElement('div');
                logoDiv.className = 'cmplz-logo-custom';
                
                // Create the SVG element
                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.setAttribute('width', '400');
                svg.setAttribute('height', '63');
                svg.setAttribute('viewBox', '0 0 400 63');
                svg.setAttribute('fill', 'none');
                svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
                
                // Add the SVG paths
                const paths = [
                    'M260.2 39.9999L263.7 35.7999C265.8 37.3999 268.3 38.0999 270.6 38.0999C272.9 38.0999 272.3 37.7999 272.3 37.2999C272.3 36.6999 271.7 36.3999 269.6 35.8999C265.2 34.9999 261.3 33.6999 261.3 29.5999C261.3 25.7999 264.2 22.8999 269.7 22.8999C275.2 22.8999 276.3 23.7999 278.6 25.5999L275.4 30.0999C273.5 28.6999 271.3 28.1999 269.5 28.1999C267.7 28.1999 268.1 28.4999 268.1 28.9999C268.1 29.5999 268.6 29.8999 270.7 30.2999C275.7 31.1999 279.1 32.6999 279.1 36.6999C279.1 40.8999 275.7 43.3999 270.4 43.3999C265.1 43.3999 262.8 42.2999 260.3 40.0999L260.2 39.9999Z',
                    'M280.1 23.2998H296.9V28.6998H286.6V30.6998H296.2V35.4998H286.6V37.5998H297.1V42.9998H280.1V23.2998Z',
                    'M298.8 23.2998H305.7L309.9 30.1998L314.1 23.2998H321V42.9998H314.4V33.1998L309.9 40.1998H309.8L305.3 33.1998V42.9998H298.8V23.2998Z',
                    'M323 23.2998H329.6V42.9998H323V23.2998Z',
                    'M331 33.1999C331 27.2999 335.6 22.8999 341.5 22.8999C347.4 22.8999 348.8 24.9999 350.4 27.9999L345 31.1999C344.3 29.7999 343.2 28.7999 341.4 28.7999C339.6 28.7999 337.7 30.6999 337.7 33.0999C337.7 35.6999 339.2 37.4999 341.4 37.4999C343.6 37.4999 344.3 36.4999 345.1 34.9999L350.5 38.0999C348.8 40.9999 346.1 43.3999 341.2 43.3999C336.3 43.3999 331 39.2999 331 33.1999Z',
                    'M350.3 33.1999C350.3 27.3999 355 22.8999 361.1 22.8999C367.2 22.8999 371.8 27.3999 371.8 33.0999C371.8 38.8999 367.1 43.3999 361 43.3999C354.9 43.3999 350.3 38.8999 350.3 33.1999ZM365.2 33.1999C365.2 30.7999 363.6 28.6999 361.1 28.6999C358.6 28.6999 357 30.7999 357 33.0999C357 35.4999 358.6 37.5999 361.1 37.5999C363.6 37.5999 365.2 35.4999 365.2 33.1999Z',
                    'M373.1 23.2998H379.3L386.3 31.9998V23.2998H392.8V42.9998H386.9L379.6 33.8998V42.9998H373.1V23.2998Z',
                    'M397.8 25.9997C398.2 25.8997 398.5 25.5997 398.5 25.0997C398.5 24.5997 398 24.1997 397.4 24.1997H396.1V27.0997H396.7V26.0997H397.3L398 27.0997H398.7L397.9 25.9997H397.8ZM397.3 25.6997H396.6V24.6997H397.3C397.7 24.6997 397.9 24.8997 397.9 25.1997C397.9 25.4997 397.7 25.6997 397.3 25.6997Z',
                    'M397.1 22.8999C395.5 22.8999 394.2 24.1999 394.2 25.7999C394.2 27.3999 395.5 28.6999 397.1 28.6999C398.7 28.6999 400 27.3999 400 25.7999C400 24.1999 398.7 22.8999 397.1 22.8999ZM397.1 28.0999C395.8 28.0999 394.8 27.0999 394.8 25.7999C394.8 24.4999 395.8 23.4999 397.1 23.4999C398.4 23.4999 399.4 24.4999 399.4 25.7999C399.4 27.0999 398.4 28.0999 397.1 28.0999Z',
                    'M58.4001 28.6001C55.8001 28.1001 52.6001 27.9001 49.1001 28.1001C38.4001 40.9001 21.4001 52.1001 9.90015 53.6001C7.20015 54.0001 5.00015 53.6001 3.40015 53.0001C4.50015 54.0001 6.30015 54.8001 8.80015 55.3001C19.7001 57.5001 39.7001 53.2001 53.4001 45.9001C67.1001 38.5001 69.3001 30.8001 58.4001 28.7001V28.6001Z',
                    'M16.3001 32.7001C27.7001 25.8001 42.5001 20.9001 55.1001 19.3001C60.5001 9.30014 57.9001 2.80014 47.9001 4.10014C35.9001 5.70014 17.6001 18.0001 7.1001 31.6001C-0.499897 41.5001 -1.8999 49.4001 2.5001 52.3001C-0.699898 47.6001 4.2001 40.0001 16.2001 32.7001H16.3001Z',
                    'M93.9 31.6999L87.7 29.9999C86 29.5999 85.1 28.7999 85.1 27.8999C85.1 26.1999 88 25.2999 90.8 25.2999C93.6 25.2999 95 26.0999 96.4 26.7999C97.3 27.1999 98 27.4999 98.6 27.4999C100.5 27.4999 100.9 26.5999 100.9 25.8999L100.6 25.0999C99.5 23.5999 94.8 22.3999 89.9 22.3999C85 22.3999 80.1 24.4999 80.1 28.0999C80.1 31.6999 83 32.2999 85.6 32.9999L92.7 34.9999C94.7 35.5999 96.7 36.2999 96.7 37.8999C96.7 39.4999 94.5 41.0999 90.4 41.0999C86.3 41.0999 85.1 39.9999 83.7 39.0999C82.8 38.5999 82 38.0999 81.2 38.0999C80.4 38.0999 79 39.0999 79 39.7999C79 41.4999 83.7 43.9999 90.2 43.9999C96.7 43.9999 101.7 41.4999 101.7 37.7999C101.7 34.0999 97.9 32.8999 93.9 31.7999V31.6999Z',
                    'M124.3 22.3999C115.5 22.3999 110.9 27.7999 110.9 33.1999C110.9 38.5999 114.6 43.9999 124.9 43.9999C135.2 43.9999 137 41.0999 137 39.5999C137 38.0999 135.4 37.8999 134.8 37.8999C134.2 37.8999 133.4 38.2999 132.5 38.7999C130.9 39.6999 128.8 40.9999 124.6 40.9999C120.4 40.9999 116.2 37.8999 115.9 34.6999H134.4C136.5 34.6999 137.5 34.0999 137.5 32.6999C137.5 27.6999 133.4 22.3999 124.3 22.3999ZM132.5 31.7999H116C116.3 28.5999 119.2 25.3999 124.3 25.3999C129.4 25.3999 132.2 28.5999 132.6 31.7999H132.5Z',
                    'M203.4 22.3999C201.9 22.3999 201.1 23.1999 201.1 24.4999V41.8999C201.1 43.1999 201.9 43.9999 203.4 43.9999C204.9 43.9999 205.7 43.1999 205.7 41.8999V24.4999C205.7 23.1999 204.9 22.3999 203.4 22.3999Z',
                    'M168.3 25.8999C170.3 23.7999 173.7 22.3999 177.2 22.3999C182.6 22.3999 188.4 24.7999 188.4 29.9999V41.7999C188.4 43.0999 187.6 43.8999 186.1 43.8999C184.6 43.8999 183.8 43.0999 183.8 41.7999V30.4999C183.8 27.0999 181.6 25.4999 177.2 25.4999C172.8 25.4999 170.5 27.2999 170.5 30.4999V41.7999C170.5 43.0999 169.7 43.8999 168.2 43.8999C166.7 43.8999 165.9 43.0999 165.9 41.7999V30.4999C165.9 27.1999 162.4 25.4999 159.2 25.4999C156 25.4999 152.6 27.1999 152.6 30.4999V41.7999C152.6 43.0999 151.8 43.8999 150.3 43.8999C148.8 43.8999 148 43.0999 148 41.7999V29.9999C148 24.7999 153.8 22.3999 159.2 22.3999C164.6 22.3999 166.1 23.7999 168.1 25.8999L168.3 26.0999L168.5 25.8999H168.3Z',
                    'M212.2 23.4003H211.6C211.5 23.4003 211.4 23.4003 211.4 23.2003C211.4 23.0003 211.4 23.0003 211.6 23.0003H213.4C213.5 23.0003 213.6 23.0003 213.6 23.2003C213.6 23.4003 213.6 23.4003 213.4 23.4003H212.8V25.6003C212.8 25.8003 212.8 25.9003 212.5 25.9003C212.2 25.9003 212.2 25.8003 212.2 25.6003V23.4003ZM214.2 23.3003C214.2 23.0003 214.3 22.8003 214.6 22.8003C214.9 22.8003 215 22.8003 215 23.1003L215.7 24.9003L216.4 23.1003C216.4 22.9003 216.7 22.8003 216.9 22.8003C217.2 22.8003 217.3 22.9003 217.3 23.3003V25.5003C217.3 25.6003 217.2 25.8003 217 25.8003C216.8 25.8003 216.7 25.7003 216.7 25.5003V23.5003L216 25.5003C216 25.7003 215.9 25.8003 215.7 25.8003C215.5 25.8003 215.5 25.8003 215.4 25.5003L214.7 23.5003V25.5003C214.7 25.6003 214.6 25.8003 214.4 25.8003C214.2 25.8003 214.1 25.7003 214.1 25.5003V23.3003H214.2Z',
                    'M236.3 7.2001C235.8 7.2001 235.5 7.5001 235.5 8.0001V58.3001C235.5 58.7001 235.9 59.1001 236.3 59.1001C236.7 59.1001 237.1 58.8001 237.1 58.3001V7.9001C237.1 7.5001 236.7 7.1001 236.3 7.1001V7.2001Z'
                ];
                
                // Create and append all path elements
                paths.forEach(pathData => {
                    const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
                    path.setAttribute('d', pathData);
                    path.setAttribute('fill', 'black');
                    svg.appendChild(path);
                });
                
                // Append SVG to logo div
                logoDiv.appendChild(svg);
                
                // Prepend the logo div to cmplz-header
                cmplzHeader.insertBefore(logoDiv, cmplzHeader.firstChild);
            }
            });
        }
    }

    function addCookiePreferencesLink() {
        // Add event listener for cmplz-show-banner class
        function addEvent(event, selector, callback, context) {
            document.addEventListener(event, e => {
                if (e.target.closest(selector)) {
                    callback(e);
                }
            });
        }
        
        addEvent('click', '.cmplz-show-banner', function(e) {
            // Prevent default link behavior
            e.preventDefault();
            // Trigger the manage consent functionality
            document.querySelectorAll('.cmplz-manage-consent').forEach(obj => {
                obj.click();
            });
        });
    }

    function initFormValidation() {
        // Initialize validation for all UM forms
        const forms = [
            document.querySelector('.um-login form'),
            document.querySelector('.um-register form'),
            document.querySelector('.um-password form')
        ];
        
        // Initialize global form validators object
        window.formValidators = window.formValidators || {};
        
        forms.forEach(form => {
            if (form) {
                const formValidator = new FormValidator(form);
                formValidator.init();
                
                // Store form validator globally for access by other functions
                window.formValidators[form] = formValidator;
            }
        });
    }

    function formatContactModal() {
        const contactModal = document.querySelector('#contact');
        if (!contactModal) return;
        
        const header = contactModal.querySelector('.modal-header');
        if (header) {
            const formHeader = document.createElement('h2');
            formHeader.className = 'modal-title';
            formHeader.textContent = 'Contact us';
            header.prepend(formHeader);
        }
        
        // Add asterisks to required field labels
        addAsterisksToLabels(contactModal);
    }
    
    function addAsterisksToLabels(container) {
        const labels = container.querySelectorAll('label');
        
        labels.forEach(label => {
            // Get all child nodes
            const childNodes = label.childNodes;
            
            childNodes.forEach(node => {
                // Only modify text nodes that have content
                if (node.nodeType === 3 && node.textContent.trim()) {
                    // Create span for asterisk
                    const asteriskSpan = document.createElement('span');
                    asteriskSpan.className = 'required-asterisk';
                    asteriskSpan.textContent = ' *';
                    
                    // Insert asterisk after the text node
                    node.after(asteriskSpan);
                }
            });
        });
    }

    function formatUSPrivacyPolicy() {
        const privacyPolicy = document.querySelector('.cmplz-document .privacy-statement.cmplz-document-us');
        if (!privacyPolicy) return;

        // Replace "organisation" with "organization" (American spelling) within the privacy policy
        const walker = document.createTreeWalker(
            privacyPolicy,
            NodeFilter.SHOW_TEXT,
            null,
            false
        );

        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
            textNodes.push(node);
        }

        textNodes.forEach(textNode => {
            if (textNode.textContent.includes('organisation')) {
                textNode.textContent = textNode.textContent.replace(/organisation/gi, 'organization');
            }
        });
    }

    function initCSVDownload() {
        const downloadBtn = document.querySelector('#download-users-csv');
        if (!downloadBtn) return;

        downloadBtn.addEventListener('click', function(e) {
            e.preventDefault();
            
            // Show loading state
            const originalText = this.innerHTML;
            this.innerHTML = '<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Downloading...';
            this.disabled = true;

            // Create form data for AJAX request
            const formData = new FormData();
            formData.append('action', 'download_users_csv');
            formData.append('nonce', window.ajax_object?.nonce || '');

            // Make AJAX request
            fetch(window.ajaxurl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.blob();
            })
            .then(blob => {
                // Create download link
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                // Set the filename with the correct format
                a.download = 'semicon-guidelines-users-export-' + new Date().toISOString().slice(0, 19).replace(/:/g, '-') + '.csv';
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
            })
            .catch(error => {
                console.error('Download failed:', error);
                alert('Download failed. Please try again.');
            })
            .finally(() => {
                // Restore button state
                this.innerHTML = originalText;
                this.disabled = false;
            });
        });
    }

	return {
		init: init,
	};
})();
